
import React from "react";
import { FormSectionElements, FormSubSections } from "src/entities/formTemplateDataType";
import classNames from 'classnames';
import { LiveValidationErrMsg } from "../live-validation-errMsg/LiveValidationErrMsg";
import { Checkbox } from "primereact/checkbox";
import FormValidationUtils from "../../utilities/FormValidationUtils";
import axios from "axios";


interface Props {
  field: FormSectionElements;
  editable: boolean;
  title;
  labelControlArray;
  requiredField;
  callbackElement;
  isEng: boolean;
}

interface State {

}
export class MultipleCheckboxComponent extends React.Component<Props, State> {


  constructor(props: Props) {
    super(props);

    let field = this.props.field;
    FormValidationUtils.runJavascript(field);
  }

  setSelectedcheckedboxes = (val) => {
    let field = this.props.field;
    if (!field.Visible) return null;
    let newVal = val;
    if (Array.isArray(val)) {
      newVal = val.join('#');
    }
    field.Value = newVal;

    const subSection: FormSubSections = field.parent as FormSubSections;
    // let list = subSection.ListOfFormSectionElements.filter(async ele => ele.FilterField == field.LoadBindBase + '.' + field.LoadBindName && ele.FilterValue.indexOf(field.Value) > -1);
    const list = subSection.ListOfFormSectionElements.filter(async ele => ele.FilterField == field.LoadBindName && ele.FilterValue.indexOf(field.Value) > -1);
    console.log(list)
    FormValidationUtils.runJavascript(field);

    this.props.callbackElement(subSection.parent.parent);

  }

  onCheckedboxesChange = (e) => {
    let field = this.props.field;
    let _selectedRecord = []

    if (this.props.field.Value != null) {
      _selectedRecord = [...field.Value.split('#')];
      _selectedRecord = _selectedRecord.filter(p => p != '')
    }

    if (e.checked) {
      _selectedRecord.push(e.value);

    }
    else {
      for (let i = 0; i < _selectedRecord.length; i++) {
        const selectedRow = _selectedRecord[i];

        if (selectedRow === e.value) {
          _selectedRecord.splice(i, 1);
          break;
        }
      }
    }

    this.setSelectedcheckedboxes(_selectedRecord);

    if (_selectedRecord.length == 0 && this.props.requiredField) {
      field.Valid = false;
      field.Touched = true;
    } else {
      field.Valid = true;
    }

    if (field.Script) {

      const customJSFunc = eval(`(${field.Script})`);
      customJSFunc();

    }

    this.props.callbackElement(field.parent.parent.parent);

  }

  async componentDidMount(): Promise<void> {
    const field = this.props.field;

    if (field.LovAPI) {

      const getUrl = field.LovAPI;
      let response;

      if (field.parent.parent.parent.UseProxy == "Y") {
        let transferPayload = {
          url: getUrl,
          httpMethod: 'GET',
          payload: ""
        }

        response = await axios.post(process.env.LAYOUT_API_URL + "/tponTransfer", transferPayload);

      } else {
        response = await axios.get(getUrl);
      }
      field.ListOfLOVValues = response.data;
      console.log(field);
    }
  }

  render() {
    let field = this.props.field;

    let editable = this.props.editable;
    let controlArray = [];
    let title = this.props.title;
    if (editable) {
      var lovCheckList = [];
      field.ListOfLOVValues.forEach(lov => {
        let selectOptionName = (this.props.isEng ? lov.description : lov.FRADescription);
        if (selectOptionName === null || selectOptionName === '') {
          selectOptionName = (this.props.isEng ? lov.code : lov.FRA);
        }
        let selectOptionValue = this.props.isEng ? lov.code : lov.FRA;

        let baseName;
        let bindName;
        let filterValue;
        let foundFilterFields: FormSectionElements[];
        let foundFilterField: FormSectionElements;
        if (lov.FilterField != null) {
          let parts = lov.FilterField.split('.');
          if (parts.length == 3) {
            baseName = parts[0] + '.' + parts[1];
            bindName = parts[2];
          }
          if (parts.length == 2) {
            baseName = parts[0];
            bindName = parts[1];
          }
          if (parts.length == 1) {
            baseName = '';
            bindName = parts[0];
          }

          let subSection: FormSubSections = field.parent as FormSubSections;
          foundFilterFields = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == bindName);
          if (foundFilterFields != null && foundFilterFields.length > 0) {
            foundFilterField = foundFilterFields[0];
          }

          if (foundFilterField) {
            filterValue = foundFilterField.Value;
          }
        }

        //if filter value is null we dont display the control
        if (filterValue != null && lov.FilterValue == filterValue || (foundFilterField == null && filterValue == null)) {
          lovCheckList.push({
            'Sequence': lov.Sequence,
            'value': selectOptionValue,
            'description': selectOptionName
          }
          );
        }
      });

      //if there is a need to filter more from element level
      if (field.FilterField != null) {
        let parts = field.FilterField.split('.');
        let baseName;
        let bindName;
        if (parts.length == 3) {
          baseName = parts[0] + '.' + parts[1];
          bindName = parts[2];
        }
        if (parts.length == 2) {
          baseName = parts[0];
          bindName = parts[1];
        }
        if (parts.length == 1) {
          baseName = '';
          bindName = parts[0];
        }

        // let foundFilterFields = XMLParser.extractFormSectionElement(baseName, bindName, this.entityType);
        let subSection: FormSubSections = field.parent as FormSubSections;
        let foundFilterFields = subSection.ListOfFormSectionElements.filter(p => p.LoadBindName == bindName);
        let foundFilterField;
        if (foundFilterFields.length == 1)
          foundFilterField = foundFilterFields.at(0);

        if (field.FilterValue == 'exclude' && lovCheckList != null && foundFilterField != null && foundFilterField.Value != null) {
          lovCheckList = lovCheckList.filter(p => foundFilterField.Value.indexOf(p.value) == -1);
        }
      }

      if (lovCheckList.length > 0) {
        controlArray.push(this.props.labelControlArray);
        controlArray.push(
          <div key={'div_' + field.Datatype + '_' + field.Id} id={'div_' + field.Datatype + '_' + field.Id} >

            <LiveValidationErrMsg
              field={this.props.field}
              isEng={this.props.isEng}
              key={"LiveValidationErrMsg_" + this.props.field.LoadBindName} />

            <div style={{ marginBottom: "2%" }}>
              {
                lovCheckList.map(val => {
                  return (<div key={'element_Checkbox_label' + val.Sequence} id={'element_Checkbox_label' + this.props.isEng + val.Sequence} className="field-Checkbox" title={val.description}>
                    <label> &nbsp;
                      {/* @ts-ignore */}
                      <Checkbox inputId={'fdIpt_Checkbox' + val.code} key={'fdIpt_Checkbox_' + this.props.isEng + val.Sequence}
                        onChange={this.onCheckedboxesChange} aria-labelledby={'element_Checkbox_label' + val.Sequence}
                        aria-checked={this.props.field.Value != null && this.props.field.Value.indexOf(val.value) > -1}
                        checked={this.props.field.Value != null && this.props.field.Value.indexOf(val.value) > -1} value={val.value} />&nbsp; {val.value}
                    </label>
                  </div>)
                })}
            </div>
          </div>

        );
      }

    } else {
      controlArray.push(
        <div className='pdf-two-column'>
          <div >{title}</div>
          <div style={{ whiteSpace: "pre-line" }} className={classNames({ 'invalid-field--highlighted': (this.props.field.Value == '' || this.props.field.Value == null) && this.props.requiredField })} > {field.Value?.split("#").join("\n")}</div>
        </div>
      );
    }

    return controlArray;
  }
}